<template>
  <div>
    <template v-if="loading_step === false">
      <div class="row uploads-wrapper">
        <ul class="col s12 no-padding collapsible clearfix uploads">
          <li v-for="(hash, key) in hashes" :ref="key" v-bind:key="key" class="col s12 no-padding">
            <div class="collapsible-header">
              {{ hashes[key].title }}
              <i v-if="possuiArquivo(key) && verificaDoc(key) === true" class="material-icons">check</i>
              <i v-else-if="verificaDoc(key) === false" class="material-icons red-text">error</i>
            </div>
            <div class="col s12 no-padding collapsible-body">
              <div class="file-field input-field">
                <div class="col s12 no-padding">
                  <div v-show="uploadInProgress[key] === true" class="loading-wrapper">
                    <loading-upload />
                  </div>
                  <div v-show="uploadInProgress[key] !== true">
                    <div v-if="key !== 'hash_dep'" class="btn-wrapper">
                      <i class="material-icons">photo_camera</i>
                      <file-storage-upload @startUpload="handleStartUpload(key)" @finishedUpload="handleFinishedUpload"
                        @failedUpload="handleFailedUpload" v-bind:ref_id="pf_id" accept="image/*,.pdf"
                        styleStr="max-height: 64px;" />
                    </div>
                    <p class="dica-digitalizacao" v-html="`Dica: ${hashes[key].info}`"></p>
                    <p v-if="key === 'hash_dep'" class="dica-digitalizacao">
                      Você deve digitalizar separadamente um ou mais documentos que contenham a Identidade(RG, CNH ou
                      Certidão de Nascimento) e o CPF de cada um dos seguintes dependentes:
                    </p>
                  </div>
                </div>

                <div v-show="uploadInProgress[key] !== true" class="col s11 m9">

                  <ul v-if="key === 'wa9tia'" class="thumbs-wrapper">
                    <p class="col s12 title-thumbs-wrapper">Imagens enviadas:</p>
                    <template v-for="(foto, i) in fotos">
                      <li v-bind:key="i">
                        <img class="materialboxed" v-bind:data-caption="`${hashes[key].title} ${i}`"
                          :src="`${url_storage}/${foto['file_id']}?q=100`" />
                        <a @click="removeImagem(foto['file_id'], key)" class="delete-btn-wrapper">
                          <i class="material-icons delete-button">clear</i>
                        </a>
                      </li>
                    </template>
                  </ul>

                  <div v-else-if="key === 'hash_dep'"> <!-- Tela de dependentes -->
                    <template v-for="(dep, index) in servidor_info.dependentes">
                      <div v-bind:key="index">
                        <div class="col s12 m9 dependente-container" v-bind:key="index">
                          <a class="waves-effect waves-light btn dica-digitalizacao"
                            @click="openModalDepUpload(dep.pf_id)">
                            <i class="material-icons left">photo_camera</i>
                            <span>
                              {{ dep.nome.split(" ").shift() }} {{ dep.nome.split(" ").pop() }}
                              <!-- <font class="hide-on-small-only"> -->
                              - {{ rel_familiar[dep.parentesco] }}
                              <!-- </font> -->
                            </span>
                          </a>
                          <br />
                        </div>
                        <div class="col s12 ">
                          <ul class="thumbs-wrapper">
                            <template v-if="dependenteDoc.find(ele => ele.pf_id === dep.pf_id)">
                              <template
                                v-for="(foto, ind) in dependenteDoc.find(ele => ele.pf_id === dep.pf_id).documentos">
                                <li v-bind:key="ind">
                                  <img class="materialboxed doc-dependente" :src="foto.url" />
                                  <a @click="removeImagem(foto['file_id'], 'all')" class="delete-btn-wrapper">
                                    <i class="material-icons delete-button">clear</i>
                                  </a>
                                </li>
                              </template>
                            </template>
                          </ul>
                        </div>
                      </div>
                    </template>
                  </div>

                  <ul v-else class="thumbs-wrapper">
                    <p class="col s12 title-thumbs-wrapper">Imagens enviadas:</p>
                    <template v-for="(doc_info, i) in docs[key]">
                      <li v-bind:key="i">
                        <img class="materialboxed" v-bind:data-caption="`${hashes[key].title} ${(i + 1)}`"
                          v-bind:src="`${url_storage}/${doc_info['file_id']}?q=100`" />
                        <a @click="removeImagem(doc_info['file_id'], key)" class="delete-btn-wrapper">
                          <i class="material-icons delete-button">clear</i>
                        </a>
                      </li>
                    </template>
                  </ul>

                </div>

              </div>
            </div>
            <div id="addImage" class="modal modalUpload">
              <div class="modal-header">
                <a @click.prevent class="modal-close">
                  <i class="material-icons right">close</i>
                </a>
                <h5 class="">Capturar imagem</h5>
              </div>
              <div class="modal-content">
                <div class="input-field">
                  <select v-model="selected_type_dep" id="sel_doc">
                    <option value selected>Selecionar Documento</option>
                    <option v-for="(doc_type, i) in meta.docs_dependentes" v-bind:key="i" v-bind:value="i">{{ doc_type
                    }}</option>
                  </select>
                  <label for="sel_doc">Selecionar Documento</label>
                </div>
                <div v-if="selected_type_dep !== null" class="file-field input-field">
                  <div v-if="uploadInProgress === true" class="loading-wrapper">
                    <loading />
                  </div>
                  <div v-else class="btn-wrapper center teste">
                    <i class="material-icons large">photo_camera</i><br>

                    <file-storage-upload @startUpload="handleStartUploadDep('hash_dep')"
                      @finishedUpload="handleFinishedUploadDep" @failedUpload="handleFailedUpload"
                      v-bind:ref_id="pf_id_dep" accept="image/*,.pdf" styleStr="max-height: 64px;" />
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="step-actions row col s12">
        <button type="button"
          class="waves-effect waves-dark btn-flat previous-step col s6 left no-padding" @click=goTo(5)>Anterior</button>
        <button v-if="step_incomplete >= 0 && step_incomplete <= 6" @click="goTo(step_incomplete)" type="button"
          class="waves-effect waves-dark btn col s6 right">REVISAR INCONSISTÊNCIAS
        </button>
        <button v-else type="button" class="waves-effect waves-dark btn col s6 right" @click="abrirModalConfirm">
            CONCLUIR
        </button>
      </div>
    </template>
    <template v-else>
      <loading-upload />
    </template>

    <div id="modal-confirm" class="modal">
      <div class="modal-content" v-html="meta.general_texts.modal_steps_done"></div>
      <div class="modal-footer">
        <a class="waves-effect red lighten-2 white-text waves-light btn-flat" @click="closeModal">Cancelar</a>
        <a @click="finalizarCadastro" class=" waves-effect teal lighten-2 white-text waves-light btn-flat">Concluir</a>
      </div>
    </div>
  </div>
</template>
<script>
import FileStorageUpload from '@/components/FileStorageUpload.vue'
import Loading from '@/components/Loading.vue'
import axios from 'axios'
import { CONFIG } from '@/config/config.js'
let uuid_service = require("uuid")

let device_info = {
  'id': uuid_service.v4().substr(0, 30),
  'log': {
    'lat': -7.98391133, //BRA HeadQuarter's location
    'lon': -34.83876744
  }
}

export default {
  name: 'Upload',
  components: {
    'file-storage-upload': FileStorageUpload,
    'loading-upload': Loading
  },
  props: {
    document_info: Object,
    servidor_info: Object,
    perfil_data: Object,
    step_incomplete: Number,
    estado_civil: String,
  },
  data() {
    return {
      meta: this.$store.state.meta.data,
      rel_familiar: this.$store.state.meta.data.rel_familiar_simples,
      uploadInProgress: {},
      pf_id: this.$store.state.user.pfId,
      pf_id_dep: null,
      // pf_id_dep_num: [],
      documentosObrigatorios: {},
      dependenteDoc: [],
      oid: this.$store.state.user.oid,
      nome: this.$store.state.user.nome,
      docs_info: this.document_info,
      selected_type: null,
      selected_type_dep: null,
      step_completed: false,
      incompleted_hashes: [],
      loading_step: true,
      selectedMunicipio: localStorage.selectedMunicipio,
      url_storage: CONFIG.URL_ARQUIVOS,
      collapsible: null,
      modalInstance: null,
    }
  },
  computed: {
    fotos() {
      let fotos_p = this.document_info.wa9tia.public
      let fotos_pr = this.document_info.wa9tia.private

      if (fotos_p.length > 0) {
        return fotos_p
      }

      if (fotos_pr.length > 0) {
        return fotos_pr
      }
      return []
    },
    hashes: function () {
      return { ...this.documentosObrigatorios }
    },
    docs() {
      let docs = {}
      Object.keys(this.docs_info).filter(k => k !== 'wa9tia').forEach((hash) => docs[hash] = this.docs_info[hash])
      return docs
    },
    verifica: function () {
      try {
        if (this.docs_info.wa9tia.private.length < 1) {
          status = false
        }

        let keys = Object.keys(this.getRequiredDocs())

        let status = true //Até que se prove o contrário
        keys.forEach((key) => {
          if (key == 'hash_dep') {
            status = this.verificaDoc('hash_dep')
          } else {
            status = this.docs_info[key].length > 0
          }
        })

        return status
      } catch (error) {
        return error
      }
    },
  },
  methods: {
    getDocumentosDependentes(pf_id) { // Requisição dos documentos dos dependentes FAZER CATCH
      axios.get(`${CONFIG.URL_STORAGE_API}/v2/docs/${pf_id}/`)
        .then(({ data: { data: { StorageAPI: { files } } } }) => {
          const filesFiltered = files.filter(file => file.author.uupfid === this.pf_id)

          this.dependenteDoc.push({
            pf_id: pf_id,
            documentos: filesFiltered
          })
        }).catch((error) => {
        })
    },
    getPFIDDependentes() { // Mapeia os dependentes fazendo uma requisição para cada.
      this.servidor_info.dependentes.map((dependente) => {
        this.getDocumentosDependentes(dependente.pf_id)
      })
    },
    openModalDepUpload(pf_id_dep) { // Abre o modal de upload
      this.pf_id_dep = pf_id_dep
      M.Modal.getInstance(document.querySelector('.modalUpload')).open()
    },
    verificaStatusPasso() {
      try {
        this.incompleted_hashes = []

        for (const hash of Object.keys(this.hashes)) {
          const status = this.verificaDoc(hash)
          if (!status) {
            this.incompleted_hashes.push(hash)
            this.step_completed = false
            break
          }
        }

        this.step_completed = this.incompleted_hashes.length === 0
        this.$emit('updateStep', 6, this.step_completed)
        return this.step_completed
      } catch (e) {
        console.error(e)
        this.step_completed = false
        return false
      }
    },
    verificaDoc(hash) {
      if (hash === "hash_dep") {
        // Se tiver dependentes...
        if (
          this.servidor_info &&
          this.servidor_info.dependentes &&
          this.servidor_info.dependentes.length > 0 &&
          this.dependenteDoc &&
          this.dependenteDoc.length > 0
        ) {
          const documento_salvo = Object.values(this.dependenteDoc).at(0)["documentos"];

          if (documento_salvo.length >= this.hashes[hash].count) {
            return true;
          }

          return false;
        } else {
          // Senão está ok
          return true;
        }
      }

      if (Object.keys(this.document_info).includes(hash)) {
        const document_req = this.hashes[hash];
        const documento_salvo = this.document_info[hash];

        // Foto de Rosto
        if (hash === "wa9tia" && (
          documento_salvo['private'].length >= document_req.count ||
          documento_salvo['public'].length >= document_req.count
        )) {
          return true;
        }

        if (documento_salvo.length >= document_req.count) {
          return true
        }
      }

      return false
    },
    possuiArquivo(hash) {
      // O check só deve aparecer quando houver arquivo enviado no campo
      if (hash === "hash_dep") {
        return this.dependenteDoc.some(dep => dep.documentos && dep.documentos.length > 0)
      }

      const documento_salvo = this.document_info[hash]
      if (!documento_salvo) {
        return false
      }

      if (hash === "wa9tia") {
        return documento_salvo['private'].length > 0 || documento_salvo['public'].length > 0
      }

      return documento_salvo.length > 0
    },
    getRequiredDocs() {
      return {}
    },
    finalizarCadastro() {
      this.loading_step = true
      axios.post(`${CONFIG.URL_RECAD_API_V2}/v1/higienize-segurado/`, {
        pf_id: this.pf_id,
        status: 'locked'
      })
        .then(() => {
          delete localStorage['reviewd']
          this.$router.push('/Status/')
        })
        .catch(() => {
          this.loading_step = false
          M.toast({ html: 'Ops! Não foi possível atender a esta solicitação neste momento...Tente novamente em instantes.' })
        })
    },
    goTo(step) {
      // Vai para a primeira ocorrência de erro de Upload
      if (step === 6) {
        const firstError = this.incompleted_hashes[0]
        const index = Object.keys(this.hashes).indexOf(firstError)

        if (index !== -1 && this.collapsible) {
          this.collapsible.open(index)
        }
      }

      this.verificaStatusPasso()
      this.$emit('goToStep', step)
    },
    handleStartUpload(hash) {
      this.selected_type = hash
      this.$set(this.uploadInProgress, this.selected_type, true)
    },
    handleStartUploadDep(hash) {
      this.selected_type = hash
      this.$set(this.uploadInProgress, this.selected_type, true)
      M.Modal.getInstance(document.querySelector('.modalUpload')).close()
    },
    handleFinishedUpload(data) {
      let file_data = {
        document_id: this.meta.hashes2docs[this.selected_type],
        file_obj: data[0]
      }

      let hash = this.selected_type

      if (this.selected_type === 'wa9tia') {
        this.addDocFoto(file_data['file_obj'], hash)
      } else if (['i0k6d5', 'er0zqc', 'ebdf70', 'd06f17'].includes(this.selected_type)) {
        this.addDocRecad(file_data['file_obj'], hash, this.pf_id)
      } else {
        this.addDoc(file_data['file_obj'], hash, this.pf_id)
      }

      // Verificar status após o upload
      this.verificaStatusPasso()
    },
    handleFinishedUploadDep(data) {
      let file_data = {
        document_id: this.meta.hashes2docs[this.selected_type_dep],
        file_obj: data[0]
      }

      let hash = this.selected_type_dep

      if (['i0k6d5', 'er0zqc', 'ebdf70', 'd06f17'].includes(this.selected_type_dep)) {
        this.addDocRecad(file_data['file_obj'], hash, this.pf_id_dep, 'Dependente')
      } else {
        this.addDoc(file_data['file_obj'], hash, this.pf_id_dep, 'Dependente')
      }
    },
    handleFailedUpload(data) {
      this.uploadInProgress[this.selected_type] = false
      this.$root.$emit('stopLoadingHeader')
      if (data.hasOwnProperty('error')) {
        M.toast({ html: data.error })
      } else {
        M.toast({ html: 'Ops! Não foi possível fazer o upload do arquivo neste momento...Tente novamente em instantes.' })
      }
    },
    addDoc(doc, hash, pf_id, dep) {
      axios.put(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/document/change/`, {
        "pf_id": pf_id,
        "file_id": doc['file_id'],
        "add": [
          hash
        ],
        "remove": [
        ],
        "device": device_info
      })
        .then((respnse) => {
          if (dep === undefined) {
            this.addItemToDocs(this.selected_type, doc['file_id'])
          } else {
            this.addItemTodependenteDoc(doc, hash, pf_id)

          }
          this.uploadInProgress[this.selected_type] = false
        })
        .catch((error) => {
          if (error.response !== 404) {
            M.toast({ html: "Ops! Não foi possível realizar esta XXXXXoperação...tente novamente em instantes." })
          }
        })
        .finally(() => {
          this.$root.$emit('stopLoadingHeader')
          M.Materialbox.init(document.querySelectorAll('.materialboxed'))
        })
    },
    addDocRecad(doc, hash, pf_id, dep) {
      axios.put(`${CONFIG.URL_RECAD_API_V2}/v1/servidor/document/change/`, {
        "pf_id": pf_id,
        "file_id": doc['file_id'],
        "add": [
          hash
        ],
        "remove": [
        ],
        "device": device_info
      })
        .then((respnse) => {
          if (dep === undefined) {
            this.addItemToDocs(this.selected_type, doc['file_id'])
          } else {
            this.addItemTodependenteDoc(doc, hash, pf_id)
          }
          this.uploadInProgress[this.selected_type] = false
        })
        .catch((error) => {
          if (typeof error === 'object' && 'response' in error && error.response !== 404) {
            M.toast({ html: "Ops! Não foi possível realizar esta operação...tente novamente em instantes." })
          }
        })
        .finally(() => {
          this.$root.$emit('stopLoadingHeader')
          M.Materialbox.init(document.querySelectorAll('.materialboxed'))
        })
    },
    addDocFoto(doc, hash) {
      axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/foto/`, {
        "pf_id": this.pf_id,
        "file_id": doc['file_id'],
        "device": device_info
      })
        .then((respnse) => {
          this.addItemToDocs(hash, doc['file_id'])
          this.uploadInProgress[hash] = false
          M.toast({ html: "Imagem enviada com sucesso!" })
        })
        .catch((error) => {
          if (error.response !== 404) {
            M.toast({ html: "Ops! Não foi possível realizar esta operação...tente novamente em instantes." })
          }
        })
        .finally(() => {
          this.$root.$emit('stopLoadingHeader')
          M.Materialbox.init(document.querySelectorAll('.materialboxed'))
        })
    },
    removeImagem(file_id, hash) {
      this.$set(this.uploadInProgress, hash, true)
      if (hash !== 'all') {
        if (hash === 'wa9tia') {
          this.removeDocFoto(file_id, hash)
        } else if (['i0k6d5', 'er0zqc', 'ebdf70', 'd06f17'].includes(hash)) {
          this.removeDocRecad(file_id, hash)
        } else {
          this.removeDoc(file_id, hash)
        }
      } else {
        this.removeDocRecad(file_id, hash)
        this.removeDoc(file_id, hash)
      }
    },
    removeDoc(file_id, hash) {
      axios.put(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/document/change/`, {
        "pf_id": this.pf_id,
        "file_id": file_id,
        "add": [],
        "remove": [
          hash
        ],
        "device": device_info
      })
        .then((respnse) => {
          this.deleteStorageFile(file_id)
          this.removeItemFromDocs(hash, file_id)
        })
        .catch((error) => {
          if (error.response !== 404 && hash !== 'all') {
            M.toast({ html: "Ops! Não foi possível realizar esta operação...tente novamente em instantes." })
          }
        })
        .finally(() => {
          this.uploadInProgress[hash] = false
          M.Materialbox.init(document.querySelectorAll('.materialboxed'))
        })
    },
    removeDocRecad(file_id, hash) {

      axios.put(`${CONFIG.URL_RECAD_API_V2}/v1/servidor/document/change/`, {
        "pf_id": this.pf_id,
        "file_id": file_id,
        "add": [],
        "remove": [
          hash
        ],
        "device": device_info
      })
        .then((respnse) => {
          this.deleteStorageFile(file_id)
          this.removeItemFromDocs(hash, file_id)
        })
        .catch((error) => {
          if (typeof error === 'object' && 'response' in error && error.response !== 404) {
            M.toast({ html: "Ops! Não foi possível realizar esta operação...tente novamente em instantes." })
          }
        })
        .finally(() => {
          this.uploadInProgress[hash] = false
          M.Materialbox.init(document.querySelectorAll('.materialboxed'))
        })
    },
    removeDocFoto(file_id, hash) {
      axios({
        method: "DELETE",
        url: `${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/foto/${this.pf_id}/${file_id}/`,
        data: {
          "device": device_info
        }
      })
        .then((respnse) => {
          this.deleteStorageFile(file_id)
          this.removeItemFromDocs(hash, file_id)
        })
        .catch((error) => {
          if (error.response !== 404) {
            M.toast({ html: "Ops! Não foi possível realizar esta operação...tente novamente em instantes." })
          }
        })
        .finally(() => {
          this.uploadInProgress[hash] = false
          M.Materialbox.init(document.querySelectorAll('.materialboxed'))
        })
    },
    addItemTodependenteDoc(doc, hash, pf_id) {
      if (this.dependenteDoc.find(ele => ele.pf_id === pf_id)) {
        this.dependenteDoc.find(ele => ele.pf_id === pf_id).documentos.push(
          {
            'pf_id': pf_id,
            'file_id': doc.file_id,
            'name': doc.name,
            'url': doc.url
          }
        )
      } else {
        this.dependenteDoc.push(
          {
            'pf_id': pf_id,
            'documentos': {
              0: {
                'pf_id': pf_id,
                'file_id': doc.file_id,
                'name': doc.name,
                'url': doc.url
              },
            }
          }
        )
      }
    },
    addItemToDocs(hash, file_id) {
      let file_obj = {
        'file_id': file_id,
        'author': {
          'oid': this.oid,
          'uupfid': this.pf_id,
          'nome': this.nome,
          'timestamp': '',
        }
      }
      if (hash !== 'wa9tia') {
        this.docs_info[hash].push(file_obj)
      } else {
        file_obj['foto_url'] = null
        this.docs_info[hash].private.push(file_obj)
      }

      this.verificaStatusPasso()
    },
    removeItemFromDocs(hash, file_id) {
      if (hash !== 'wa9tia') {
        if (hash !== 'all') {
          this.docs_info[hash].forEach((doc, i) => {
            if (doc['file_id'] === file_id) {
              this.docs_info[hash].splice(i, 1)
            }
          })
        } else {
          this.dependenteDoc.forEach((dep_doc, i) => {
            dep_doc.documentos.forEach((doc, j) => {
              if (doc['file_id'] === file_id) {
                this.dependenteDoc[i].documentos.splice(j, 1)
              }
            })
          })
        }
      } else {
        this.docs_info[hash].private.forEach((foto, i) => {
          if (foto['file_id'] === file_id) {
            this.docs_info[hash].private.splice(i, 1)
          }
        })
      }
      this.verificaStatusPasso()
    },
    deleteStorageFile(file_id) {
      axios.delete(`${CONFIG.URL_STORAGE_API}/v2/doc/${file_id}/delete/`)
        .then((response) => {
        })
        .catch((error) => {
          M.toast({ html: `Ops! Não foi possível remover esta imagem no momento...tente novamente em instantes.` })
          this.errorDel = true
        })
    },
    setDocumentos() {
      const lista = this.meta.censo_domain[this.selectedMunicipio].formulario_documentos_obrigatorios.uploads;
      if (!lista || lista.length === 0) {
        this.documentosObrigatorios = { "": "" };
        return;
      }

      const documentos = {};
      lista.forEach((doc) => {

        // CASO ESPECIAL: estado civil
        if (doc.kilwf3) {
          const estadoCivil = doc["kilwf3"][this.estado_civil] || doc["kilwf3"]["sy77y6"];
          documentos["kilwf3"] = estadoCivil;
          return;
        }

        // FILTRO POR CATEGORIA
        if (!doc.categoria_cods) {
          return;
        }

        const categoria_docs = doc.categoria_cods.some((cat) =>
          this.servidor_info.categoria_cods.includes(cat)
        );

        if (categoria_docs) {
          documentos[doc.hash] = doc;
        }
      });

      // Se não tiver dependentes cadastrados, retira o hash
      if (!(this.servidor_info.dependentes && this.servidor_info.dependentes.length)) {
        delete documentos["hash_dep"];
      }

      this.documentosObrigatorios = documentos;
    },
    initStep() {
      try {
        M.Materialbox.init(document.querySelectorAll('.materialboxed'))
        const elem = document.querySelector('.collapsible.uploads')
        this.collapsible = M.Collapsible.init(elem)
      } catch (e) {
        console.error("Erro ao selecionar elementos:", e)
      }
    },
    abrirModalConfirm() {
      this.modalInstance.open()

      const modal = document.getElementById('modal-confirm')
      modal.style.zIndex = 2000
    },
    initModal() {
      const elem = document.getElementById('modal-confirm')
      if (!elem) return

      this.modalInstance = M.Modal.init(elem)
    },
    closeModal() {
      if (this.modalInstance) {
        this.modalInstance.close()

        const elem = document.getElementById('modal-confirm')
        if (elem) {
          elem.style.zIndex = -100

          document.querySelectorAll('.modal-overlay').forEach(o => o.remove())
          document.body.style.overflow = ''
        }
      }
    },
  },
  watch: {
    docs_info: {
      handler: function (updated_docs, old_perfil) {
        this.changed = true
        this.$nextTick(() => this.verificaStatusPasso())
      },
    },
    servidor_info: {
      handler: function ( oldVal, newVal ) {
        if (!newVal) return;

        // Atualiza os documentos conforme atualiza os dados funcionais
        this.setDocumentos();
      },
      deep: true
    },
    document_info: {
      handler: function (updated_docs, old_perfil) {
        this.$nextTick(() => this.docs_info = this.document_info)
      },
    }
  },
  mounted() {
    this.initModal()

    this.setDocumentos()
    this.verificaStatusPasso()

    this.$nextTick(() => this.getPFIDDependentes())
    this.loading_step = false
  },
  updated() {
    if (this.dependenteDoc.length == 0 && this.servidor_info.dependentes.length > 0) {
      this.getPFIDDependentes()
    }
  },
  beforeDestroy() {
    if (this.modalInstance) {
      this.modalInstance.destroy()
    }
  }
}
</script>

<style scoped>
.modal {
  height: 50% !important;
  border-radius: 10px;
  border-top: 5px #039be5 solid;
}

.modal .modal-header {
  border-bottom: 2px #cfcfcf solid;
  padding: 0rem 1.5rem 0px 1.5rem;
}

.doc-dependente {
  max-width: 15rem;
  border-radius: 10px;
}

.dependente-container {
  padding-top: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/steps/Upload.vue